import { useCallback, useEffect, useRef, useState } from 'react'

function debounce<TFn extends (...args: unknown[]) => void>(fn: TFn, ms: number): TFn {
  let timeoutId: number
  return function (this: unknown, ...args: unknown[]) {
    clearTimeout(timeoutId)
    timeoutId = window.setTimeout(() => fn.apply(this, args), ms)
  } as TFn
}

export const useTableHeightListener = (): [number | undefined, (el: HTMLDivElement | null) => void] => {
  const tableRef = useRef<HTMLDivElement>()
  const [tableHeight, setTableHeight] = useState<number>()

  const updater = () => {
    const current = tableRef.current
    if (current) {
      const tableOffset = current.getBoundingClientRect().top || 0
      setTableHeight(tableOffset)
    }
  }

  useEffect(() => {
    const handleResize = debounce(updater, 500)
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [updater])
  const ref = useCallback(
    (el: HTMLDivElement | null) => {
      if (!el) return
      tableRef.current = el
      updater()
    },
    [updater],
  )
  return [tableHeight, ref]
}
